








import { defineComponent, ref } from "@nuxtjs/composition-api";
import { json2html } from "html2json_2";
// import { assign } from "lodash-es";

export default defineComponent({
  name: "ElementsText",
  props: {
    tag: {
      type: String,
      default: "div",
    },
    node: {
      type: String,
      default: "div",
    },
    attr: {
      type: Object,
      default: () => {},
    },
    children: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const htmlContent = ref("");

    const data = {
      tag: props.tag,
      node: props.node,
      attr: props.attr,
      child: props.children,
    };
    htmlContent.value = json2html(data);

    return {
      htmlContent,
    };
  },
});
